import config from '@/config';
import { setLoader } from '@/store/Reducer/Loader/LoaderReducer';
import store from '@/store/store';
import axios from 'axios';
import { toast } from 'react-toastify';

const exemptedToastError = [`${config.apiUrl}user/process-pending-payment`];

const axiosApi = axios.create();

axiosApi.interceptors.request.use((req: any) => {
  const exemptedRequest = [``];
  if (exemptedRequest.includes(req.url)) {
    store.dispatch(setLoader(false));
  } else {
    store.dispatch(setLoader(true));
  }
  req.headers.Authorization = `Bearer ${
    localStorage.getItem('token') ? localStorage.getItem('token') : ''
  }`;
  return req;
});

/****** Intercepts Response ********/
axiosApi.interceptors.response.use(
  (response: any) => {
    store.dispatch(setLoader(false));
    if (response?.data?.status === 'success' && response?.data?.message) {
      toast.dismiss();
      toast.success(response.data.message);
    }
    return response;
  },
  (error: any) => {
    store.dispatch(setLoader(false));
    if (error?.response?.status) {
      if (error.response.status === 401) {
        toast.dismiss();
        toast.error('Unauthorized');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      } else {
        if (
          !exemptedToastError.includes(error.config.url) &&
          error.response?.data?.message
        ) {
          toast.dismiss();
          toast.error(error.response.data.message);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
